/* eslint-disable max-lines */
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
import CatalogueView from "@/components/Catalogue/CatalogueView.vue";
import ProductPromoCode from "@/components/PromoCode/product_promo_code.vue";
import { get_token, get_user_details, getCookie, csrf_headers } from "@/router";
import {
    append_active_organization_form_data,
    append_active_organization_id,
    is_enabled_feature,
    is_organization_admin_role
} from "@/utils/organization_profile";
import Swal from "sweetalert2";
import { my_shop_helpers } from "./my_shop_helper";
import {
    dedupe_marketplace_listings,
    format_price,
    view_profile_product
} from "@/views/Marketplace/marketplace_helpers";
import { create_marketplace_catalogue_realtime_methods } from "@/views/Marketplace/marketplace_realtime_helper";
import {
    add_attribute_value,
    group_attributes,
    remove_attribute
} from "@/views/BusinessProfileView/business_profile_helper";

function create_item_form() {
    return {
        name: "",
        price: null,
        description: "",
        attributes: {}
    };
}

function create_update_item_form() {
    return {
        product_id: "",
        name: "",
        price: "",
        description: "",
        subcategory_id: "",
        attributes: {},
    };
}

const my_shop_realtime_methods = create_marketplace_catalogue_realtime_methods({
    listing_type: "product",
    include_orders: true,
});

export default {
    name: "MyShopView",
    components: {
        HomeNavBar,
        CatalogueView,
        ProductPromoCode,
    },
    inject: ["client_features"],
    data() {
        return ({
            loading: true,
            errors: {},
            user_details: get_user_details() || {},
            base_profile_id: null,
            active_home_profile: null,
            shop_profile: null,
            profile_products: [],
            catalogue_products: [],
            orders: [],
            product_types: [],
            isLoading: false,
            create_action_loading: null,
            isEditing: false,
            is_deleting: false,
            isDragging: false,
            modal_product: "",
            upload_files: [],
            previews: [],
            active_modal_image_index: 0,
            categories: [],
            subcategories: [],
            selected_category: "",
            selected_subcategory: "",
            attributeTypes: [],
            new_attribute_value: {},
            is_catalogue_sale_selecting: false,
            selected_catalogue_sale_product_ids: [],
            modalType: "product",
            item_form: create_item_form(),
            update_item_form: create_update_item_form(),
            advertisements: [],
            advertisement_product: null,
            advertisement_id: null,
            advertisement_title: "",
            advertisement_description: "",
            advertisement_redirect_url: "",
            advertisement_is_active: false,
            is_saving_advertisement: false,
        });
    },
    computed: {
        catalogue_items() {
            return this.catalogue_products;
        },
        can_create_business_profile_action() {
            return is_enabled_feature(this.client_features?.show_business_profile)
                && !is_organization_admin_role(this.user_details);
        },
        product_create_permission() {
            return append_active_organization_id() ? "products" : null;
        },
        new_orders_count() {
            return this.orders.filter((order) => this.is_new_order(order)).length;
        },
        catalogueTab() {
            return "products";
        },
        view_model() {
            return this;
        },
        isDeleting: {
            get() {
                return this.is_deleting;
            },
            set(value) {
                this.is_deleting = value;
            },
        },
        shop_title() {
            return this.active_home_profile?.profile_name
                || this.active_home_profile?.company_name
                || this.active_home_profile?.name
                || this.shop_profile?.profile_name
                || this.shop_profile?.company_name
                || this.shop_profile?.name
                || "My Shop";
        },
        product_advertisements() {
            if (!this.advertisement_product?.id) return [];
            return this.advertisements.filter(
                (advertisement) => String(advertisement?.product?.id)
                    === String(this.advertisement_product.id)
            );
        },
    },
    mounted() {
        this.loading = true;
        this.get_active_base_products()
            .then(() => Promise.allSettled([
                this.fetch_product_types(),
                this.get_attribute_types(),
                this.get_orders(),
                this.fetch_advertisements(),
                this.ensure_advertisement_csrf_cookie(),
            ]))
            .catch((error) => {
                this.errors.page_load = error?.message || "Failed to load shop data.";
            })
            .finally(() => {
                this.loading = false;
                this.$nextTick(() => {
                    this.open_actions_offcanvas_from_route();
                });
            });
        window.addEventListener("realtime:event", this.handle_marketplace_realtime_event);
    },
    beforeUnmount() {
        window.removeEventListener("realtime:event", this.handle_marketplace_realtime_event);
    },
    methods: {
        ...my_shop_helpers,
        ...my_shop_realtime_methods,
        open_actions_offcanvas_from_route() {
            this.open_actions_offcanvas("myShopActionsOffcanvas");

            if (this.$route.query.open_actions === "1") {
                this.$router.replace({
                    name: this.$route.name,
                    params: this.$route.params,
                    query: {
                        ...this.$route.query,
                        open_actions: undefined,
                    },
                });
            }
        },
        open_actions_offcanvas(offcanvas_id) {
            const offcanvas_el = document.getElementById(offcanvas_id);
            if (!offcanvas_el) return;

            if (window.bootstrap?.Offcanvas) {
                window.bootstrap.Offcanvas.getOrCreateInstance(offcanvas_el).show();
                return;
            }

            $(`#${offcanvas_id}`).offcanvas("show");
        },
        getToken() {
            return get_token();
        },
        sync_catalogue_items(items = []) {
            const deduped_items = dedupe_marketplace_listings(items);
            this.profile_products = deduped_items;
            this.catalogue_products = deduped_items.filter(
                (product) => this.is_shop_product(product)
            );
        },
        set_active_home_profile(profile) {
            this.active_home_profile = profile || null;

            if (profile?.id && !this.base_profile_id) {
                this.base_profile_id = profile.id;
                this.get_orders();
            }

            if (profile) {
                this.shop_profile = profile;
            }
        },
        open_business_profile_from_actions() {
            this.$refs.homeNavBarRef?.open_company_profile_modal?.();
        },
        fetch_product_types() {
            return new Promise((resolve, reject) => {
                $.ajax({
                    type: "GET",
                    url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_product_types/`,
                    headers: {
                        Authorization: `Token ${this.getToken()}`,
                    },
                    success: (response) => {
                        if (response.status === "success") {
                            this.product_types = response.data || [];
                            resolve(response.data);
                            return;
                        }
                        reject(new Error(response.message || "Failed to load product types."));
                    },
                    error: (xhr) => {
                        reject(new Error(xhr.responseJSON?.message || "Failed to load product types."));
                    }
                });
            });
        },
        get_attribute_types() {
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_attribute_types/`,
                    type: "GET",
                    headers: {
                        Authorization: `Token ${this.getToken()}`,
                        "Content-Type": "application/json",
                    },
                    success: (response) => {
                        if (response.status === "success") {
                            this.attributeTypes = response.data || [];
                            resolve(response.data);
                            return;
                        }
                        reject(new Error(response.message || "Failed to load attribute types."));
                    },
                    error: (xhr) => {
                        reject(new Error(xhr.responseJSON?.message || "Failed to load attribute types."));
                    }
                });
            });
        },
        go_back() {
            this.$router.back();
        },
        view_product_details(product) {
            view_profile_product(this.$router, product);
        },
        get_order_status(order = {}) {
            return String(order?.order_status_name || order?.order_status || "").trim().toLowerCase();
        },
        is_new_order(order = {}) {
            return this.get_order_status(order) === "pending";
        },
        set_modal_type(type) {
            this.modalType = type || "product";
            this.selected_category = "";
            this.selected_subcategory = "";
            this.item_form.attributes = {};
            this.fetch_categories();
        },
        validate_item_form() {
            this.errors = {};
            let has_error = false;

            if (!this.item_form.name || !this.item_form.name.trim()) {
                this.errors.name = "Product name is required";
                has_error = true;
            }
            if (this.item_form.price === "" || this.item_form.price === null) {
                this.errors.price = "Product price is required";
                has_error = true;
            } else if (Number(this.item_form.price) <= 0) {
                this.errors.price = "Price must be greater than 0";
                has_error = true;
            }

            return has_error;
        },
        reset_product_form() {
            this.errors = {};
            this.item_form = create_item_form();
            this.update_item_form = create_update_item_form();
            this.modalType = "product";
            this.isEditing = false;
            this.selected_category = "";
            this.selected_subcategory = "";
            this.subcategories = [];
            this.upload_files = [];
            this.previews = [];
            this.isLoading = false;
            this.new_attribute_value = {};
            this.active_modal_image_index = 0;
        },
        cancel_edit() {
            this.isEditing = false;
            this.reset_product_form();
        },
        close_add_item_modal() {
            this.reset_product_form();
            $("#addItemModal").modal("hide");
        },
        close_manage_modal() {
            this.reset_product_form();
            $("#manageProductModal").modal("hide");
        },
        open_product_promo_code_manager(product) {
            if (!product?.id) return;

            this.modal_product = product;
            $("#manageProductModal").modal("hide");

            this.$nextTick(() => {
                this.$refs.productPromoCodeRef?.open_product_promo_code_manager_modal?.(product);
            });
        },
        fetch_advertisements() {
            return new Promise((resolve) => {
                $.ajax({
                    url: `${process.env.VUE_APP_BACKEND_API_URL}/ads_management/get_advertisements_by_user_profile/`,
                    method: "POST",
                    xhrFields: { withCredentials: true },
                    headers: {
                        Authorization: `Token ${this.getToken()}`,
                        "Content-Type": "application/json",
                    },
                    data: JSON.stringify(append_active_organization_id({})),
                    success: (response) => {
                        this.advertisements = Array.isArray(response?.data) ? response.data : [];
                        resolve(this.advertisements);
                    },
                    error: () => resolve([]),
                });
            });
        },
        open_product_advertisement(product) {
            if (!product?.id) return;
            this.reset_advertisement_form();
            this.advertisement_product = product;
            $("#manageProductModal").one("hidden.bs.modal", () => {
                $("#productAdvertisementModal").modal("show");
            });
            $("#manageProductModal").modal("hide");
        },
        reset_advertisement_form() {
            this.advertisement_id = null;
            this.advertisement_title = "";
            this.advertisement_description = "";
            this.advertisement_redirect_url = "";
            this.advertisement_is_active = false;
            this.is_saving_advertisement = false;
        },
        start_new_advertisement() {
            const product = this.advertisement_product;
            this.reset_advertisement_form();
            this.advertisement_product = product;
            this.advertisement_is_active = Boolean(product?.is_published);
        },
        edit_advertisement(advertisement) {
            this.advertisement_id = advertisement.id;
            this.advertisement_title = advertisement.title || "";
            this.advertisement_description = advertisement.description || "";
            this.advertisement_redirect_url = advertisement.redirect_url || "";
            this.advertisement_is_active = Boolean(advertisement.is_active);
        },
        get_advertisement_image() {
            return this.advertisement_product?.images?.[0]?.image_url || "";
        },
        async ensure_advertisement_csrf_cookie() {
            let csrf_token = getCookie("csrftoken");
            if (csrf_token) return csrf_token;

            const response = await fetch(
                `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_csrf_token/`,
                {
                    method: "GET",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Page-URL": window.location.href,
                    },
                }
            );
            if (!response.ok) {
                throw new Error("Unable to initialize secure advertisement requests.");
            }

            csrf_token = getCookie("csrftoken");
            if (!csrf_token) {
                throw new Error("The CSRF cookie could not be set.");
            }
            return csrf_token;
        },
        normalize_advertisement_url(url) {
            const value = String(url || "").trim();
            if (!value || /^https?:\/\//i.test(value)) return value;
            return `https://${value}`;
        },
        build_advertisement_form_data() {
            const form_data = new FormData();
            form_data.append("product_id", this.advertisement_product.id);
            form_data.append("title", this.advertisement_title || this.advertisement_product.name || "");
            form_data.append("description", this.advertisement_description || "");
            form_data.append("is_active", Boolean(
                this.advertisement_product.is_published && this.advertisement_is_active
            ));
            const redirect_url = this.normalize_advertisement_url(this.advertisement_redirect_url);
            if (redirect_url) form_data.append("redirect_url", redirect_url);
            if (this.advertisement_id) form_data.append("advertisement_id", this.advertisement_id);
            return append_active_organization_form_data(form_data);
        },
        handle_saved_advertisement(response) {
            if (response.status !== "success") return;
            const saved = response.data;
            const index = this.advertisements.findIndex((item) => item.id === saved.id);
            if (index === -1) this.advertisements.unshift(saved);
            else this.advertisements.splice(index, 1, saved);
            this.start_new_advertisement();
            Swal.fire({
                icon: "success",
                title: "Advertisement saved",
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 1800,
            });
        },
        handle_advertisement_request_error(xhr) {
            Swal.fire({
                icon: "error",
                text: xhr.responseJSON?.message || "Unable to save advertisement.",
            });
        },
        async save_product_advertisement() {
            if (!this.advertisement_product?.id || this.is_saving_advertisement) return;
            this.is_saving_advertisement = true;
            let csrf_token;
            try {
                csrf_token = await this.ensure_advertisement_csrf_cookie();
            } catch (error) {
                this.is_saving_advertisement = false;
                Swal.fire({ icon: "error", text: error.message });
                return;
            }
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/ads_management/${this.advertisement_id ? "update_advertisement" : "create_advertisement"}/`,
                method: "POST",
                xhrFields: { withCredentials: true },
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    ...csrf_headers(csrf_token),
                },
                data: this.build_advertisement_form_data(),
                processData: false,
                contentType: false,
                success: this.handle_saved_advertisement,
                error: this.handle_advertisement_request_error,
                complete: () => {
                    this.is_saving_advertisement = false;
                },
            });
        },
        async toggle_product_advertisement(advertisement) {
            let csrf_token;
            try {
                csrf_token = await this.ensure_advertisement_csrf_cookie();
            } catch (error) {
                Swal.fire({ icon: "error", text: error.message });
                return;
            }
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/ads_management/toggle_advertisement_is_active/`,
                method: "POST",
                xhrFields: { withCredentials: true },
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    ...csrf_headers(csrf_token),
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(append_active_organization_id({
                    advertisement_id: advertisement.id,
                })),
                success: () => {
                    advertisement.is_active = !advertisement.is_active;
                },
                error: (xhr) => Swal.fire({
                    icon: "error",
                    text: xhr.responseJSON?.message || "Unable to change advertisement status.",
                }),
            });
        },
        delete_product_advertisement(advertisement) {
            Swal.fire({
                title: "Delete advertisement?",
                text: "This action cannot be undone.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Delete",
            }).then(async (result) => {
                if (!result.isConfirmed) return;
                let csrf_token;
                try {
                    csrf_token = await this.ensure_advertisement_csrf_cookie();
                } catch (error) {
                    Swal.fire({ icon: "error", text: error.message });
                    return;
                }
                $.ajax({
                    url: `${process.env.VUE_APP_BACKEND_API_URL}/ads_management/delete_advertisement/`,
                    method: "POST",
                    xhrFields: { withCredentials: true },
                    headers: {
                        Authorization: `Token ${this.getToken()}`,
                        ...csrf_headers(csrf_token),
                        "Content-Type": "application/json",
                    },
                    data: JSON.stringify(append_active_organization_id({
                        advertisement_id: advertisement.id,
                    })),
                    success: (response) => {
                        if (response.status === "success") {
                            this.advertisements = this.advertisements.filter(
                                (item) => item.id !== advertisement.id
                            );
                            if (this.advertisement_id === advertisement.id) {
                                this.start_new_advertisement();
                            }
                        }
                    },
                });
            });
        },
        open_catalogue_promo_code_manager() {
            const products = (this.catalogue_products || []).filter(
                (product) => product?.id && this.is_shop_product(product)
            );
            if (!products.length) return;

            this.$nextTick(() => {
                this.$refs.productPromoCodeRef?.open_catalogue_promo_code_manager_modal?.({
                    products,
                    base_profile_id: this.base_profile_id,
                });
            });
        },
        open_catalogue_sale_form_modal() {
            const products = this.get_selected_catalogue_sale_products();
            if (!products.length) return;

            this.is_catalogue_sale_selecting = false;

            this.$nextTick(() => {
                this.$refs.productPromoCodeRef?.open_product_sale_modal?.({
                    products,
                    base_profile_id: this.base_profile_id,
                    applies_all: this.has_all_catalogue_sale_products_selected(),
                });
            });
        },
        get_sale_eligible_catalogue_products() {
            return (this.catalogue_products || []).filter(
                (product) => this.is_catalogue_sale_product_eligible(product)
            );
        },
        get_sale_eligible_catalogue_product_ids() {
            return this.get_sale_eligible_catalogue_products().map((product) => Number(product.id));
        },
        has_all_catalogue_sale_products_selected() {
            const eligible_ids = this.get_sale_eligible_catalogue_product_ids();
            const selected_ids = new Set(this.selected_catalogue_sale_product_ids.map(String));

            return Boolean(
                eligible_ids.length &&
                eligible_ids.every((product_id) => selected_ids.has(String(product_id)))
            );
        },
        is_catalogue_sale_product_eligible(product) {
            return Boolean(
                product?.id &&
                this.is_shop_product(product)
            );
        },
        is_shop_product(product) {
            const product_type_name = String(product?.product_type?.name || "").toLowerCase();
            return !product_type_name || product_type_name === "product";
        },
        get_selected_catalogue_sale_products() {
            const selected_ids = new Set(this.selected_catalogue_sale_product_ids.map(String));
            return this.get_sale_eligible_catalogue_products().filter(
                (product) => selected_ids.has(String(product.id))
            );
        },
        start_catalogue_sale_selection() {
            this.is_catalogue_sale_selecting = true;
            this.selected_catalogue_sale_product_ids = [];
        },
        cancel_catalogue_sale_selection() {
            this.is_catalogue_sale_selecting = false;
            this.selected_catalogue_sale_product_ids = [];
        },
        is_catalogue_sale_product_selected(product) {
            return this.selected_catalogue_sale_product_ids.map(String).includes(String(product?.id));
        },
        toggle_catalogue_sale_product(product) {
            if (!product?.id) return;
            if (!this.is_catalogue_sale_product_eligible(product)) return;

            const product_id = Number(product.id);

            if (this.is_catalogue_sale_product_selected(product)) {
                this.selected_catalogue_sale_product_ids = this.selected_catalogue_sale_product_ids.filter(
                    (selected_id) => String(selected_id) !== String(product_id)
                );
                return;
            }

            this.selected_catalogue_sale_product_ids.push(product_id);
        },
        toggle_all_catalogue_sale_products() {
            const product_ids = this.get_sale_eligible_catalogue_product_ids();
            if (this.has_all_catalogue_sale_products_selected()) {
                this.selected_catalogue_sale_product_ids = [];
                return;
            }

            this.selected_catalogue_sale_product_ids = product_ids;
        },
        update_parent_product_promos(payload) {
            const product_id = String(payload?.product_id || this.modal_product?.id || "");
            const promo = payload?.promo;
            if (!product_id || !promo) return;

            const product = (this.profile_products || []).find(
                (item) => String(item.id) === product_id
            ) || this.modal_product;
            if (!product) return;

            const currentPromos = product.product_promo_codes || product.promo_codes || [];
            const promoIndex = currentPromos.findIndex(
                (item) => String(item.id) === String(promo.id)
            );

            if (promoIndex === -1) {
                currentPromos.unshift(promo);
            } else {
                currentPromos.splice(promoIndex, 1, promo);
            }

            product.product_promo_codes = currentPromos;

            if (String(this.modal_product?.id) === product_id) {
                this.modal_product = product;
            }
        },
        normalize_product_sale_assignment(assignment) {
            if (!assignment?.product?.id || !assignment?.sale) return null;

            return ({
                product_id: String(assignment.product.id),
                product: Object.assign({}, assignment.product, {
                    sale: Object.assign({}, assignment.sale, {
                        sale_price: assignment.sale_price,
                        is_active: assignment.is_active ?? assignment.sale?.is_active,
                    }),
                }),
            });
        },
        build_product_sale_update_map(assignments) {
            const sale_updates = (assignments || [])
                .map((assignment) => this.normalize_product_sale_assignment(assignment))
                .filter(Boolean);

            return new Map(
                sale_updates.map((update) => [update.product_id, update.product])
            );
        },
        merge_product_sale_update(product, product_updates) {
            const updated_product = product_updates.get(String(product?.id));
            return updated_product ? Object.assign({}, product, updated_product) : product;
        },
        has_modal_product_sale_update(product_updates) {
            if (!this.modal_product?.id) return false;
            return product_updates.has(String(this.modal_product.id));
        },
        update_product_sale_collection(products, product_updates) {
            return (products || [])
                .map((product) => this.merge_product_sale_update(product, product_updates));
        },
        update_parent_product_sales(payload) {
            const product_updates = this.build_product_sale_update_map(payload.sale);
            if (!product_updates.size) return;

            this.profile_products = this.update_product_sale_collection(this.profile_products, product_updates);
            this.catalogue_products = this.update_product_sale_collection(this.catalogue_products, product_updates);

            if (this.has_modal_product_sale_update(product_updates)) {
                this.modal_product = this.merge_product_sale_update(this.modal_product, product_updates);
            }
        },
        handle_parent_product_promo_deletion(payload) {
            const product_id = String(payload?.product_id || this.modal_product?.id || "");
            const promo_id = String(payload?.promo_id || "");
            if (!product_id || !promo_id) return;

            const product = (this.profile_products || []).find(
                (item) => String(item.id) === product_id
            ) || this.modal_product;
            if (!product) return;

            const currentPromos = product.product_promo_codes || product.promo_codes || [];
            product.product_promo_codes = currentPromos.filter(
                (promo) => String(promo.id) !== promo_id
            );

            if (String(this.modal_product?.id) === product_id) {
                this.modal_product = product;
            }
        },
        handleImagesUpload(event) {
            const files = Array.from(event.target.files || []);
            if (!files.length) return;
            const supported_files = files.filter((file) => this.is_supported_media_file(file));
            const has_unsupported_files = supported_files.length !== files.length;

            if (has_unsupported_files) {
                this.errors.product_images = "Only image and video files can be uploaded.";
            }

            if (!supported_files.length) {
                event.target.value = "";
                return;
            }

            if (!has_unsupported_files && supported_files.some((file) => file.type.startsWith("image/"))) {
                this.errors.product_images = null;
            }

            supported_files.forEach((file) => {
                this.upload_files.push(file);
                if (file.type.startsWith("image/")) {
                    const reader = new FileReader();
                    reader.onload = (load_event) => {
                        this.previews.push({
                            type: "image",
                            src: load_event.target.result,
                            name: file.name,
                            file,
                        });
                    };
                    reader.readAsDataURL(file);
                    return;
                }

                const url = URL.createObjectURL(file);
                this.previews.push({
                    type: "video",
                    src: url,
                    name: file.name,
                    file,
                });
            });

            event.target.value = "";
        },
        is_supported_media_file(file) {
            return file?.type?.startsWith("image/") || file?.type?.startsWith("video/");
        },
        handle_drop(event) {
            this.isDragging = false;
            const files = event.dataTransfer.files;
            if (files.length > 0) {
                this.handleImagesUpload({ target: { files } });
            }
        },
        remove_file(index) {
            const file = Reflect.get(this.previews, index);
            if (file.id) {
                // Existing image: mark for deletion
                file._delete = true;
            } else {
                // Newly uploaded file: remove from upload_files and previews
                const fileIndex = this.upload_files.indexOf(file.file);
                if (fileIndex > -1) this.upload_files.splice(fileIndex, 1);
                this.previews.splice(index, 1);
            }
            },
        prev_modal_image() {
            const total = this.modal_product?.images?.length || 0;
            if (!total) return;
            this.active_modal_image_index = (this.active_modal_image_index - 1 + total) % total;
        },
        next_modal_image() {
            const total = this.modal_product?.images?.length || 0;
            if (!total) return;
            this.active_modal_image_index = (this.active_modal_image_index + 1) % total;
        },
        add_attribute_value(type) {
            const target_form = this.isEditing ? this.update_item_form : this.item_form;
            add_attribute_value(target_form, this.new_attribute_value, type);
        },
        handle_attribute_input_keydown(event, type) {
            if (!event || !type) return;
            if (event.key === "Enter" || event.key === ",") {
                event.preventDefault();
                this.add_attribute_value(type);
            }
        },
        group_attributes(attributes) {
            return group_attributes(attributes);
        },
        remove_attribute(item_form, type_name, index) {
            return remove_attribute(item_form, type_name, index);
        },
        display_price(product) {
            if (this.has_active_product_sale(product)) {
                return this.get_product_sale_price(product);
            }

            return product?.final_price ?? product?.price ?? 0;
        },
        should_show_product_sale(product) {
            return this.has_active_product_sale(product);
        },
        get_sale_discount_type_name(product) {
            const discount_type = product?.sale?.discount_type;
            return typeof discount_type === "object" && discount_type !== null
                ? String(discount_type?.name || "").toLowerCase()
                : "";
        },
        is_percentage_sale_discount(product) {
            return ["percentage", "percent"].includes(this.get_sale_discount_type_name(product));
        },
        has_active_product_sale(product) {
            const sale = product?.sale || {};
            return Boolean(
                sale?.is_active &&
                Number(sale?.discount_amount || 0) > 0
            );
        },
        get_product_original_price(product) {
            return Number(product?.price ?? product?.final_price ?? 0);
        },
        has_provided_product_sale_price(product) {
            const provided_sale_price = product?.sale?.sale_price;
            return ![undefined, null, ""].includes(provided_sale_price);
        },
        calculate_product_discounted_price(product, original_price, discount_amount) {
            if (this.is_percentage_sale_discount(product)) {
                return Math.max(0, original_price - ((original_price * discount_amount) / 100));
            }

            return Math.max(0, original_price - discount_amount);
        },
        get_product_sale_price(product) {
            const original_price = this.get_product_original_price(product);
            const discount_amount = Number(product?.sale?.discount_amount || 0);

            if (this.has_provided_product_sale_price(product)) {
                return Number(product?.sale?.sale_price);
            }

            return this.calculate_product_discounted_price(product, original_price, discount_amount);
        },
        get_product_sale_discount_label(product) {
            const original_price = this.get_product_original_price(product);
            if (original_price <= 0) return "-0%";

            const sale_price = this.get_product_sale_price(product);
            const discount_percentage = ((original_price - sale_price) / original_price) * 100;

            return `-${Math.round(Math.max(0, discount_percentage))}%`;
        },
        format_price(value) {
            return format_price(value);
        },
        format_date(datestr) {
            const date = new Date(datestr);
            const day = date.getDate();
            const suffix = ((d) => {
                if (d > 3 && d < 21) return "th";
                switch (d % 10) {
                    case 1: return "st";
                    case 2: return "nd";
                    case 3: return "rd";
                    default: return "th";
                }
            })(day);

            const weekday = date.toLocaleDateString("en-US", { weekday: "long" });
            const month = date.toLocaleDateString("en-US", { month: "long" });
            const year = date.getFullYear();

            return `${weekday}, ${month} ${day}${suffix}, ${year}`;
        },
        view_all_orders() {
            this.$router.push({ name: "orders", query: { base_profile_id: this.base_profile_id } });
        },
    },
};
